"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DateConvert", {
  enumerable: true,
  get: function () {
    return _DateConvert.DateConvert;
  }
});
Object.defineProperty(exports, "DecimalsConvert", {
  enumerable: true,
  get: function () {
    return _DecimalsConvert.DecimalsConvert;
  }
});
Object.defineProperty(exports, "MappingConvert", {
  enumerable: true,
  get: function () {
    return _MappingConvert.MappingConvert;
  }
});
Object.defineProperty(exports, "TimeDifferenceConvert", {
  enumerable: true,
  get: function () {
    return _TimeDifferenceConvert.TimeDifferenceConvert;
  }
});
exports.createDefaultConvertTypes = createDefaultConvertTypes;
var _ConvertTypeRegistry = require("./ConvertTypeRegistry");
var _DecimalsConvert = require("./type/DecimalsConvert");
var _DateConvert = require("./type/DateConvert");
var _TimeDifferenceConvert = require("./type/TimeDifferenceConvert");
var _MappingConvert = require("./type/MappingConvert");
var _JsonConvert = require("./type/JsonConvert");
function createDefaultConvertTypes() {
  return new _ConvertTypeRegistry.ConvertTypeRegistry().register(new _DecimalsConvert.DecimalsConvert()).register(new _DateConvert.DateConvert()).register(new _TimeDifferenceConvert.TimeDifferenceConvert()).register(new _MappingConvert.MappingConvert()).register(new _JsonConvert.JsonConvert());
}
//# sourceMappingURL=types.js.map